import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionServicesInfoForm_ResolvableServiceUsages_FlushAll_Mutation =
  graphql(`
    mutation MissionServicesInfoForm_ResolvableServiceUsages_FlushAll(
      $serviceUserId: Id!
      $versionData: VersionDataInput
    ) {
      flushMissionServiceUsages(
        serviceUserId: $serviceUserId
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export const useFlushAllMissionResolvableServiceUsagesMutation = () =>
  useGraphQLMutation(
    MissionServicesInfoForm_ResolvableServiceUsages_FlushAll_Mutation,
  );
